module.exports = __webpack_public_path__ + "img/bg_header_image.24ba356a.png";